import $ from 'jquery';

$('.jobform__toggle-extended-filter').on('click', function (e) {
    e.preventDefault();
    $(this).closest('.jobform').find('.jobform__extended-filter').addClass('jobform__extended-filter--open');
    $(this).closest('.jobform').find('.jobform__extended-filter-input').val(1);
    $(this).closest('.jobform').find('.jobform__submit--top').addClass('jobform__submit--hide');
    $(this).addClass('jobform__toggle-extended-filter--hide');
});